module.exports = __webpack_public_path__ + "static/media/logoBanner.c9a0a7f1.png";